import { defineChain } from 'viem'

export default defineChain({
	id: 88883,
	name: 'Chiliz Chain Staging',
	network: 'chiliz-chain-staging',
	rpcUrls: {
		default: {
			http: ['https://ccv2-rpc-staging.chiliz.com']
		}
	},
	blockExplorers: {
		default: {
			name: 'Chiliz Staging Explorer',
			url: 'https://ccv2-explorer-staging.chiliz.com'
		}
	},
	nativeCurrency: {
		name: 'Chiliz',
		symbol: 'CHZ',
		decimals: 18
	},
	testnet: true,
	maxSupply: 8888888888000000
})
